<template>
  <div class="wx_warp">
    <div class="fromesLint" style="height:30px">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-date-picker
            v-model="value2"
            type="datetimerange"
            :range-separator="dataobjs.zhi"
            :start-placeholder="dataobjs.kaishiriqi"
            :end-placeholder="dataobjs.jieshuriqi"
            format="yyyy-MM-dd   HH:mm:ss"
            value-format="yyyy-MM-dd   HH:mm:ss"
          ></el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-input v-model="businessname" :placeholder="dataobjs.qingshuruyewumingcheng"></el-input>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" style="padding: 7px 20px !important;" @click="getdataXt">{{dataobjs.chaxun}}</el-button>
        </el-col>
      </el-row>
    </div>

    <div class="tablesLint">
      <el-table
        :data="tableData"
        :row-class-name="tableRowClassName"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
      >
        <el-table-column prop="username" :show-overflow-tooltip="true" :label="dataobjs.yonghuming"></el-table-column>

        <el-table-column prop="businessname" :label="dataobjs.yewumingcheng"></el-table-column>
        <!-- <el-table-column prop="ip" :label="dataobjs.ipdizhi"></el-table-column> -->
        <el-table-column prop="operationtype" :label="dataobjs.caozuoleixing"></el-table-column>

        <el-table-column prop="addtime" :label="dataobjs.caozuoshijian"></el-table-column>
        <el-table-column prop="state" :label="dataobjs.caozuozhuangtai"></el-table-column>
        <el-table-column prop="operation" :label="dataobjs.caozuomiaoshu" :show-overflow-tooltip="true"></el-table-column>
      </el-table>
      <!-- 分页 :get-table-list="Dealerinfo" -->
      <page-helper :page-data="pageData" :total="total" :get-table-list="getdataXt"></page-helper>
    </div>
  </div>
</template>

<script>
import PageHelper from "@/components/common/PageHelper";
import { getdataXt,lang_fend } from "@/network/index";
export default {
  components: {
    PageHelper
  },
  data() {
    return {
      tableData: [],
      pageData: {
        pagenum: 1, //页码  pagenum  2
        pagesize: 30 //数据   pagesize几条数据
      },
      total: null,
      value2: "",
      businessname: "",
      Delectloading: false, //加载图表
      textContent: "正在努力加载中...", //加载提示文字
       lang_file: sessionStorage.getItem("lang_file"),
       dataobjs:{}
    };
  },
  created() {},
  mounted() {
    this.getdataXt();
    this.lang_fend()
  },
  methods: {
        //翻译
    async lang_fend() {
      let page = "userlog_page";
      let objs = {
        page,
        lang_file: this.lang_file,
      };
      const { data, code } = await lang_fend(objs);
      this.dataobjs = data;
    },
    // 斑马线
    tableRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    async getdataXt() {
 
         let begindate = this.value2[0] == undefined ? '' : this.value2[0];
        let enddate = this.value2[1] == undefined? '' : this.value2[1];
      
      let { pagenum, pagesize } = this.pageData;
      let {businessname} = this
      const { code, data, msg } = await getdataXt(
        pagenum,
        pagesize,
        begindate,
        enddate,
        businessname
      );
      if (code) {
        this.total = Number(data.pagelist[0].allrow);
        this.tableData = data.list;
      } else {
        this.$message.error(msg);
      }
    }
  }
};
</script>

<style scoped>
.wx_warp {
  width: 99%;
  height: 300px;
  
}
.tablesLint {
  /* height: 500px; */
  /* height: 100%; */
  /* overflow: auto; */
  width: 100%;
}
</style>
